import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { BrandID } from '@/types/common/course'

export const useAutoAddStore = defineStore('autoAdd', () => {
  const state = {
    autoAddBrandID: ref(BrandID.ALL),
    nextBrandID: ref<BrandID | null>(null),
    isUseCashBackModalVisible: ref(false),
    isAutoAddModalVisible: ref(false),
    isAboutAutoAddModalVisible: ref(false),
    isBTCRuleModalVisible: ref(false),
    isBTCRuleModalShowCheckbox: ref(true),
    isBTCRuleModalChecked: ref(!!localStorage.getItem('BTCRuleModalChecked') || false),
    isOpenAutoAddModalAfterCloseBTCRuleModal: ref(true),
  }

  const computeds = {
    isAutoAddEnabled: computed<boolean>(() => {
      return state.autoAddBrandID.value !== BrandID.NONE
    }),
  }

  const actions = {
    setAutoAddBrandID(val: BrandID) {
      state.autoAddBrandID.value = val
    },

    setNextBrandID(val: BrandID) {
      state.nextBrandID.value = val
    },

    setIsUseCashBackModalVisible(val: boolean) {
      state.isUseCashBackModalVisible.value = val
    },

    setIsAutoAddModalVisible(val: boolean) {
      state.isAutoAddModalVisible.value = val
    },

    setIsAboutAutoAddModalVisible(val: boolean) {
      state.isAboutAutoAddModalVisible.value = val
    },

    setIsBTCRuleModalVisible(
      visible: boolean,
      showCheckbox = true,
      isOpenAutoAddModalAfterClose = true,
    ) {
      state.isBTCRuleModalVisible.value = visible
      state.isBTCRuleModalShowCheckbox.value = showCheckbox
      state.isOpenAutoAddModalAfterCloseBTCRuleModal.value = isOpenAutoAddModalAfterClose

      if (!visible && state.isOpenAutoAddModalAfterCloseBTCRuleModal.value) {
        this.setIsAutoAddModalVisible(true)
      }
    },

    setIsBTCRuleModalChecked(val: boolean) {
      state.isBTCRuleModalChecked.value = val
      if (val) {
        localStorage.setItem('BTCRuleModalChecked', 'true')
      } else {
        localStorage.removeItem('BTCRuleModalChecked')
      }
    },
  }

  return {
    ...state,
    ...computeds,
    ...actions,
  }
})
